export enum TagsAndMetadataTabs {
  Tags,
  ThemeTags,
  Metadata,
}

export type TabProps = {
  id: string;
  "aria-controls": string;
};

export type Tab = {
  id: TagsAndMetadataTabs;
  label: string;
};
